<template>
  <div class="textbox">
    <textarea
      spellcheck="false"
      :aria-label="acessibleLabel"
      :value="value"
      @input="inputTextbox"
    />
    <ButtonIconContextual
      class="textbox__clear-button"
      icon="EF0031"
      size="small"
      label="Limpar campo"
      @click="$emit('clear')"
    />
  </div>
</template>

<script setup lang="ts">
import { ButtonIconContextual } from '@warrenbrasil/nebraska-web';

interface Props {
  value: string;
  acessibleLabel?: string;
}
defineProps<Props>();

interface EmitEvents {
  (event: 'input', value: string): void;
  (event: 'clear'): void;
}

const emit = defineEmits<EmitEvents>();

function inputTextbox(event: Event) {
  const target = event.target as HTMLTextAreaElement;
  emit('input', target.value.replace(/\s+/g, ' ').trim());
}
</script>

<style lang="less" scoped>
.textbox {
  display: flex;
  border-bottom: @size-border-x500 solid @divider-primary;
  margin-top: @size-spacing-x600;

  &:focus-within {
    border-bottom-color: @element-primary;
  }

  textarea {
    .text-p-3();
    line-height: 30px;
    padding: @size-spacing-x75;
    max-width: 464px;
    width: 100%;
    height: 60px;
    border: 0;
    outline: 0;
    resize: none;
    scrollbar-width: none;
  }

  &__clear-button {
    align-self: center;
  }
}
</style>
